export default class Database {
  dbVersion = 1

  doInTransaction (tableName, f) {
    // console.log('Inside Database.doInTransaction')
    var request = window.indexedDB.open('TLS', this.dbVersion)
    var database = null
    request.onerror = function (event) {
      console.log('Failed to open database: ' + event)
    }
    request.onupgradeneeded = function (event) {
      database = event.target.result
      database.createObjectStore('ContractorPallets', { autoIncrement: true })
      database.createObjectStore('ContractorCommands', { autoIncrement: true })
    }
    request.onsuccess = function (event) {
      database = event.target.result
      var tx = database.transaction([tableName], 'readwrite')
      tx.oncomplete = function (event) {
        // console.log('Transaction is ready')
      }
      tx.onerror = function (event) {
        console.log('Failed to start transaction: ' + event)
      }
      f(tx)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascript/database.js